/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Checkbox  } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { TreeSelect } from 'primereact/treeselect';
import { Tree } from 'primereact/tree';
        


import ListUserModal from '@components/Admins/ListUserModal'
import { CLEAR_VALUES_ADMIN } from '@constants/actionType'
import { getValueLanguageObj } from '@utils/general'

import store from '@store'

const ROLE_AUXILIAR_PDD_ID = 14;
const ROLE_AUXILIAR_OC_ID = 16;

class AddEvaluatorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countriesSelect: [],
      isAllCountriesVisible: false,
      isAllCompaniesVisible: false,
      btnSubmitLoading: false,
      nodeRegionesSelect: [],
      expandedKeys: {},
      errors: [],
      modalListUser: {
        isVisible: false
      },
      tipoRol: {
        isRRHH: false,
        isOC: false,
        isCE: false,
        isCAMX: false,
        isCoordinatedAssistant: false
      },
      selectedComplianceOfficer: null,
      justification: ''
    }
  }
  
  async componentDidMount() {
    const {roleSelected, userSelect, user, setSelectedNodeKeys} = this.props
    let countriesSelect = []
    let nodeSelecion = []
    let allPaises = false
    let allEmpresas = false
    let isAllCompaniesVisible = false
    let isAllCountriesVisible = false
    const tipoRol=
      {
        isOC: roleSelected === 3,
        isCAMX: roleSelected === 9,
        isRRHH: roleSelected === 11,
        isCE: roleSelected === 12,
        isCoordinatedAssistant: [ROLE_AUXILIAR_PDD_ID, ROLE_AUXILIAR_OC_ID].includes(roleSelected)
      }
    if(!userSelect){
      store.dispatch({type: CLEAR_VALUES_ADMIN})
      setSelectedNodeKeys([])
    } else { 
      if(user) {  
        const {admin_paises, admin_empresas} = user
        
        if(admin_paises === 'ALL' || admin_empresas === 'ALL'){
          if(admin_paises === 'ALL'){
            allPaises = true
            isAllCountriesVisible = true
          }
          if(admin_empresas === 'ALL'){
            allEmpresas = true
            isAllCompaniesVisible = true
          }
        }

        if(tipoRol.isOC){
          countriesSelect = user.paises.map(u => u.id)
        } else if(tipoRol.isRRHH){
          nodeSelecion = await this.getSelectedNodeKeys(user)
        }
        
      }
    }

    let expandedKeys = {}
    nodeSelecion.map(p => {
      expandedKeys[p.key] = true
      p?.children?.map(e => {
        expandedKeys[e.key] = true
      })
    })

    this.setState({
      tipoRol: tipoRol,
      countriesSelect: countriesSelect,
      nodeRegionesSelect: nodeSelecion,
      expandedKeys: expandedKeys,
      admin_empresas: allEmpresas,
      admin_paises: allPaises,
      isAllCompaniesVisible: isAllCompaniesVisible,
      isAllCountriesVisible: isAllCountriesVisible
    })
  }

  componentDidUpdate(prevProps) {
    const prevUserMail = prevProps.user?.correo
    const currentUserMail = this.props.user?.correo
    if (prevUserMail !== currentUserMail) {
      this.setState({ selectedComplianceOfficer: null })
    }
  }

  getSelectedNodeKeys = (user) => {
    let objectSel = []
    if(user){
      
      user?.paises?.map(country => {
        const isCountryAll = false
        const childrenCountry = []
        country?.empresas?.map(company => {
          const childrenCompany = []
          company?.regiones?.map(region => {
            const dataRegion = {
              key: `P${country.id}-E${company.id}-R${region.id}`, 
              label: `${region.nombre}`, 
              data: `${region.nombre} Region`,
              id: region.id
            }
            childrenCompany.push(dataRegion)
          })

          const dataCompany = {
            key: `P${country.id}-E${company.id}`, 
            label: `${company.nombre}`, 
            data: `${company.nombre} Empresa`,
            children: childrenCompany,
            id: company.id
          }
          childrenCountry.push(dataCompany)
        })

        const companyName = getValueLanguageObj(JSON.parse(country.nombre))
        const dataCountry = {
          key: `P${country.id}`, 
          label: `${companyName}`, 
          data: `${companyName} País`,
          children: childrenCountry,
          id: country.id
        }
        objectSel.push(dataCountry)
      })
      
    }
    return objectSel
  }

  onSubmit = async () => {
    const { onAction, user, paisesSelected, regiones } = this.props
    const { countriesSelect, isAllCountriesVisible, isAllCompaniesVisible, justification, tipoRol, selectedComplianceOfficer  } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
    const data = {
      correo: user.correo,
      admin_empresas: 'ALL',
      admin_paises: 'ALL'
    }
    if(tipoRol.isRRHH) {
      data.admin_paises = 'SOME'
      data.admin_empresas = 'SOME'
      if(isAllCompaniesVisible){
        let paisesSelectedAll = regiones.map(p => {
            const empresas = p?.children?.map(e => {
              const regiones = e?.children?.map(r => {
                return {id: r.id}
              })
              return {id: e.id, regiones}
           })
           return {id: p.id, empresas}
        })
        data.paises = paisesSelectedAll
      } else {
        data.paises = paisesSelected
      }
    } else {
      if(!isAllCountriesVisible && tipoRol.isOC){
        data.admin_paises = 'SOME'
        data.paises = countriesSelect.map(item => ({id: item}))
      }
    }
    if(tipoRol.isCoordinatedAssistant) {
      data.id_coordinador = selectedComplianceOfficer
    }
    console.log("data envia", data)
    onAction(data, justification)
  }

  validateFieldsReject = async () => {
    const { t, user } = this.props
    const { countriesSelect, isAllCountriesVisible, nodeRegionesSelect, justification, tipoRol, isAllCompaniesVisible, selectedComplianceOfficer } = this.state
    let errors = {}
    if (!user) errors = { ...errors, 'user': `${t('Seleccione un usuario')} ${t('es requerido')}`}
    if (!isAllCountriesVisible && !countriesSelect.length && tipoRol.isOC) errors = { ...errors, [`countriesSelect`]: 'countriesSelect es requerido' }
    if (tipoRol.isCoordinatedAssistant && user && !selectedComplianceOfficer) errors = { ...errors, [`selectedComplianceOfficer`]: `${t('Oficial de Cumplimiento')} ${t('es requerido')}` }
    if (tipoRol.isRRHH && !nodeRegionesSelect.length && !isAllCompaniesVisible ) {errors = { ...errors, [`regionSelect`]: 'regionSelect es requerido' }
    
  }
    if (!justification) errors = { ...errors, 'justification': `${t('Justificación del cambio')} ${t('es requerido')}`}

    this.setState({errors})
    return errors
  }

  onChange = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  onShowModalSearchUser = (value) => {
    this.setState({ modalListUser: { isVisible: value } })
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  onChangeCheck = (e) => {
    const { countriesSelect } = this.state
    const selectedCountry = [...countriesSelect];

    if(e.checked)
      selectedCountry.push(e.value);
    else
      selectedCountry.splice(selectedCountry.indexOf(e.value), 1);

    this.setState(
      { countriesSelect: selectedCountry, isAllCountriesVisible: false},
      () => this.validateFieldsOnchange(`countriesSelect`, true)
    );
  }

  onChangeAllCountries = (e) => {
    this.setState({isAllCountriesVisible: e.value, countriesSelect: []}, () => this.validateFieldsOnchange(`countriesSelect`, true))
  }

  onChangeAllCompanies = (e) => {
    const {setSelectedNodeKeys } = this.props
    setSelectedNodeKeys([])
    this.setState({isAllCompaniesVisible: e.checked, nodeRegionesSelect: []}, () => this.validateFieldsOnchange(`regionSelect`, true))
  }
  onSelect = (e) => {

    this.validateFieldsOnchange(`regionSelect`, true)
    this.validateFieldsOnchange(`countriesSelect`, true)
    const {id,tipo} = e.node
    let newNodeRegionesSelect = this.state.nodeRegionesSelect
    switch (tipo) {
      case 'n':
          newNodeRegionesSelect = []
          const cloneNodeNuevo = {...e.node}
          newNodeRegionesSelect.push(cloneNodeNuevo)
      case 'p':
          newNodeRegionesSelect = newNodeRegionesSelect.filter(p => p.id !== id)

          const cloneNode = {...e.node}
          newNodeRegionesSelect.push(cloneNode)
        break;
      case 'e':
        const idPais = e.node.pais.id
        const labelPais = e.node.pais.label
        const pais = newNodeRegionesSelect.find(p => p.id === idPais)
        const cloneNodeE = {...e.node}
        if(pais){
         
          pais.children.push(cloneNodeE)
        } else {
          let children = []
          children.push(cloneNodeE)
          const newPais = {
            key: `P${idPais}`,
            data: `${labelPais} Pais`,
            label: labelPais,
            id: idPais,
            children
          }
          newNodeRegionesSelect.push(newPais)
        }
        break;
      case 'r':
        const idPaisR = e.node.pais.id
        const labelPaisR = e.node.pais.label
        const idEmpresa = e.node.empresa.id
        const labelEmpresa = e.node.empresa.label
        const paisR = newNodeRegionesSelect.find(p => p.id === idPaisR)
        const cloneNodeR = {...e.node}
        if(paisR){
          const empresa = paisR?.children?.find(em => em.id === idEmpresa)
          if(empresa){
            empresa?.children?.push(cloneNodeR)
          } else {
            let children = []
            children.push(cloneNodeR)
            const newEmpresa = {
              key: `P${idPaisR}-E${idEmpresa}`,
              data: `${labelEmpresa} Empresa`,
              label: labelEmpresa,
              id: idEmpresa,
              children
            }
            paisR?.children?.push(newEmpresa)
          }
        } else {
          let children = []
            children.push(cloneNodeR)
            const newEmpresa = {
              key: `P${idPaisR}-E${idEmpresa}`,
              data: `${labelEmpresa} Empresa`,
              label: labelEmpresa,
              id: idEmpresa,
              children
            }

          let childrenPais = []
          childrenPais.push(newEmpresa)

          
          const newPais = {
            key: `P${idPaisR}`,
            data: `${labelPaisR} Pais`,
            label: labelPaisR,
            id: idPaisR,
            children: childrenPais
          }

          newNodeRegionesSelect.push(newPais)
        }
        break;
      default:
        break;
    }


    let expandedKeys = {}
    newNodeRegionesSelect.map(p => {
      expandedKeys[p.key] = true
      p?.children?.map(e => {
        expandedKeys[e.key] = true
      })
    })
    this.setState({nodeRegionesSelect: newNodeRegionesSelect, expandedKeys: expandedKeys})
  };

  onUnselect = (e) => {
    console.log('this.props.node antes', this.props.regiones)
    this.validateFieldsOnchange(`regionSelect`, true)
    this.validateFieldsOnchange(`countriesSelect`, true)
    const {id,tipo} = e.node
    let newNodeRegionesSelect = this.state.nodeRegionesSelect
    switch (tipo) {
      case 'p':
        newNodeRegionesSelect = newNodeRegionesSelect.filter(p => p.id !== id)
        break;
      case 'e':
        
        const idPais = e.node.pais.id
        let pais = newNodeRegionesSelect.find(p => p.id === idPais)
        
        const newEmpresas = pais.children.filter(em => em.id !== id)
        pais.children = newEmpresas

        newNodeRegionesSelect = newNodeRegionesSelect.filter(p => p.id !== idPais)
        if(newEmpresas.length) newNodeRegionesSelect.push(pais)

        console.log('this.props.node', this.props.regiones)
        break;
      case 'r':
        const idPaisR = e.node.pais.id
        const idEmpresaR = e.node.empresa.id
        let paisR = newNodeRegionesSelect.find(p => p.id === idPaisR)
        let empresaR = paisR.children.find(em => em.id === idEmpresaR)
        
        const newRegiones = empresaR.children.filter(r => r.id !== id)
        if(newRegiones.length) {
          empresaR.children = newRegiones
          let newChildrenPais = paisR.children.filter(em => em.id !== idEmpresaR)
          newChildrenPais.push(empresaR)
          paisR.children = newChildrenPais
          newNodeRegionesSelect = newNodeRegionesSelect.filter(p => p.id !== idPaisR)
          newNodeRegionesSelect.push(paisR)
        } else {
          let newChildrenPais = paisR.children.filter(em => em.id !== idEmpresaR)
          newNodeRegionesSelect = newNodeRegionesSelect.filter(p => p.id !== idPaisR)
          if(newChildrenPais.length) {
            paisR.children = newChildrenPais
            newNodeRegionesSelect.push(paisR)
          }
        }
        
        break;
      default:
        break;
    }


    let expandedKeys = {}
    newNodeRegionesSelect.map(p => {
      expandedKeys[p.key] = true
      p?.children?.map(e => {
        expandedKeys[e.key] = true
      })
    })
    this.setState({nodeRegionesSelect: newNodeRegionesSelect, expandedKeys: expandedKeys})
  }

  render () {
    const { t, onHidden, user, countriesCatalog, btnLoading, title, regiones, catalogBusiness, selectedNodeKeys, setSelectedNodeKeys, userSelect, complianceOfficers } = this.props
    const { errors, modalListUser, countriesSelect, isAllCountriesVisible, tipoRol, nodeRegionesSelect, expandedKeys, isAllCompaniesVisible, selectedComplianceOfficer } = this.state
    console.log('selectedNodeKeys',regiones)
    const isFormFieldValid = (name) =>
    !!(errors[name]);
  
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );
    
    const renderCountruiesOption = () => countriesCatalog.map(item => (
      <div className="p-col-6 p-field-checkbox p-mb-0" key={item.label}>
        <Checkbox
          inputId={`cb${item.id}`}
          name="countriesSelect"
          value={item.id}
          onChange={this.onChangeCheck}
          checked={countriesSelect.indexOf(item.id) !== -1}
          className={classNames({
            'p-invalid': isFormFieldValid(`countriesSelect`),
          })}
        />
        <label >{item.label}</label>
      </div>
    ))

    const getCountriesLabel = (item) => {
      if (item?.admin_paises === 'ALL') return t('Todos los países')
      if (item?.pais) return item.pais
      if (item?.pais_nombre) return item.pais_nombre
      if (item?.paises?.length) {
        return item.paises.map(country => getValueLanguageObj(JSON.parse(country.nombre))).join(', ')
      }
      return ''
    }

    const complianceOfficerOptions = (complianceOfficers || [])
      .map(item => {
        const countryLabel = getCountriesLabel(item)
        return {
          countryLabel,
          label: `${countryLabel} - ${item.nombre} - ${item.correo}`,
          value: item.id_usuario || item.fi_id || item.id
        }
      })
      .sort((current, next) =>
        current.countryLabel.localeCompare(next.countryLabel, 'es', { sensitivity: 'base' })
          || current.label.localeCompare(next.label, 'es', { sensitivity: 'base' })
      )
    const isComplianceOfficerDisabled = tipoRol.isCoordinatedAssistant && !user

    const children = (
      <div className="p-mt-2 p-grid">
        <div className="p-col-12 p-field">
          <label htmlFor="title" className="p-text-bold">
            {t('Nombre')}
          </label>
          { user ? (
            <div className="p-d-flex p-ai-center">
              <label className="p-mr-4">
                {user.nombre}
              </label>
              { !userSelect &&
                  <Button
                  type="button"
                  icon="pi pi-pencil"
                  onClick={() => this.onShowModalSearchUser(true)}
                  style={{ marginRight: '.5em' }}
                  className=" p-button-text p-button-primary"
                />
              }
            </div>
            ) : (
            <div className="p-d-flex p-ai-center">
              <label
                htmlFor="title"
                className={classNames({
                  'p-error': isFormFieldValid(`user`),
                })}
              >
                {t('Seleccione un usuario')}
              </label>
              <Button
                label={t('Buscar usuario')}
                type="button"
                onClick={() => this.onShowModalSearchUser(true)}
                className=" p-button-text p-button-primary"
              />
            </div>
          )}
        </div>
        { tipoRol.isCoordinatedAssistant &&
          <div className="p-col-12 p-field">
            <label className="p-text-bold">{t('Oficial de Cumplimiento')}</label>
            <Dropdown
              name="selectedComplianceOfficer"
              value={selectedComplianceOfficer}
              options={complianceOfficerOptions}
              onChange={(e) =>
                !isComplianceOfficerDisabled && this.setState({ selectedComplianceOfficer: e.value }, this.validateFieldsOnchange('selectedComplianceOfficer', e.value))
              }
              disabled={isComplianceOfficerDisabled}
              filter
              optionLabel="label"
              placeholder={isComplianceOfficerDisabled ? t('Seleccione primero un usuario') : t('Seleccione un Oficial de Cumplimiento')}
              className={classNames('is-full-width', {
                'p-invalid': isFormFieldValid(`selectedComplianceOfficer`),
              })}
              style={{ width: '100%' }}
            />
            {getFormErrorMessage(`selectedComplianceOfficer`)}
          </div>
        }
        { (tipoRol.isOC || tipoRol.isCAMX || tipoRol.isCE) &&
          <div className="p-col-12 p-field">
            <label className="p-text-bold">{t('Países que puede administrar')}</label>
          </div>
        }
        { (tipoRol.isRRHH) &&
          <div className="p-col-12 p-field">
            <label className="p-text-bold">{t('Empresas que puede administrar')}</label>
          </div>
        }
        
        
        {(tipoRol.isOC || tipoRol.isCE || tipoRol.isCAMX) &&
          <div className="p-col-12 p-field p-field-radiobutton">
            <Checkbox
              name="isAllCountriesVisible"
              value
              onChange={this.onChangeAllCountries}
              
              checked={isAllCountriesVisible || tipoRol.isCE || tipoRol.isCAMX}
              //enabled={tipoRol.isCE || tipoRol.isCAMX}
              className={classNames({
                'p-invalid': isFormFieldValid(`countriesSelect`),
              })}
            />
            <label>{t('Todos los países')}</label>
          </div>
        }
        { tipoRol.isOC && renderCountruiesOption() }
        
        {/*tipoRol.isRRHH &&
          <div className="p-col-12 p-field p-field-radiobutton">
            <Checkbox
              name="isAllCompaniesVisible"
              onChange={this.onChangeAllCompanies}
              value
              checked={isAllCompaniesVisible}
              //enabled={tipoRol.isCE || tipoRol.isCAMX}
              className={classNames({
                'p-invalid': isFormFieldValid(`regionSelect`),
              })}
            />
            <label>{t('Todas las empresas')}</label>
          </div>
            */}
        
        {(tipoRol.isRRHH && !isAllCompaniesVisible) && 
          <>
            <div className="p-col-12 p-field">
                <TreeSelect value={selectedNodeKeys} style={{width: "50%"}} onChange={(e) => setSelectedNodeKeys(e.value)} options={regiones} 
                     onNodeSelect={(e) => this.onSelect(e)}
                     onNodeUnselect={(e) => this.onUnselect(e)}
                    filter metaKeySelection={false} className={classNames('md:w-20rem w-full', {
                      'p-invalid': isFormFieldValid(`regionSelect`),
                    })} selectionMode="checkbox" display="chip" placeholder="Selecionar empresas"></TreeSelect>
            </div>
            {nodeRegionesSelect.length > 0 && <Tree value={nodeRegionesSelect} expandedKeys={expandedKeys} onToggle={(e) => this.setState({expandedKeys: e.value})}/>}
            
          </>
        }


        
        <div className='p-col-12 p-field p-mb-0'>
          <label className="">{t('Justificación del cambio')}</label>
        </div>
        <div className='p-col-12 p-field'>
          <InputTextarea
            name="justification"
            onChange={(e) =>
              this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
            }
            autoResize 
            rows={5}
            // cols={30}
            className={classNames('is-full-width', {
              'p-invalid': isFormFieldValid(`justification`),
            })}
          />
          {getFormErrorMessage(`justification`)}
        </div>
        <div className="p-col-12 p-dialog-footer custom">
          <div className="p-d-flex p-jc-between">
            <Button
              label={t('Cerrar')}
              type="button"
              className="p-button-secondary p-button-text p-button-raised"
              onClick={onHidden}
            />
            <Button
              label={t('Guardar')}
              type="button"
              onClick={() => this.onSubmit()}
              className="p-button-primary"
              loading={btnLoading}
            />
          </div>
        </div>
        { modalListUser.isVisible && (
          <ListUserModal
            onHidden={() => this.onShowModalSearchUser(false)}
            setSelectedNodeKeys={(value) => setSelectedNodeKeys(value)}
            countriesCatalog={countriesCatalog}
            catalogBusiness={catalogBusiness}
            regiones={regiones}
            tipoRol={tipoRol}
            onChangeAllCompanies={(e) => this.onChangeAllCompanies(e)}
            onSelectEmpresas={(value) => this.onSelect(value)}
          />
        )}
    </div>
    )

    return (
      <Dialog
        header={title}
        visible
        breakpoints={{'960px': '90vw'}}
        style={{ width: '50vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.admins.user,
  countriesCatalog: state.catalogs.countriesCurrentCatalog
});

export default compose(withTranslation(), connect(mapStateToProps, null))(AddEvaluatorModal)

